import { DataModelBuilder, SerializationContext, SerializedData } from '../../../dto/data-model.js';
import { Payload } from '../payload.js';
import { PayloadType } from '../payload-type.js';
import { MapUtils } from '../../../../utility/map-utils.js';
import { Country } from '../../country.js';
import { toEnumFromString } from '../../../../serialization/enum-utils.js';
import { Language } from '../../language.js';

export class BusinessChangedPayload extends Payload {
  static readonly TYPE_ID = '58b879561f4f4f7fa2033d2897c4bdff';

  private constructor(
    public readonly businessId: string,
    public readonly organizationId: string,
    public readonly country: Country,
    public readonly language: Language,
  ) {
    super();
  }

  get $typeId(): string {
    return BusinessChangedPayload.TYPE_ID;
  }

  get type(): PayloadType {
    return PayloadType.BusinessChanged;
  }

  static create(args: {
    businessId: string;
    organizationId: string;
    country: Country;
    language: Language;
  }): BusinessChangedPayload {
    return new BusinessChangedPayload(args.businessId, args.organizationId, args.country, args.language);
  }

  static fromMap(_context: SerializationContext, map: SerializedData): BusinessChangedPayload {
    return BusinessChangedPayload.create({
      businessId: MapUtils.getString(map, 'businessId'),
      organizationId: MapUtils.getString(map, 'organizationId'),
      country: toEnumFromString(MapUtils.getString(map, 'country'), Country),
      language: toEnumFromString(MapUtils.getString(map, 'language'), Language),
    });
  }

  toMap(_context: SerializationContext): SerializedData {
    return {
      'businessId': this.businessId,
      'organizationId': this.organizationId,
      'country': this.country,
      'language': this.language,
    };
  }

  clone(): this {
    return this.copyWith();
  }

  copyWith({
    businessId = this.businessId,
    organizationId = this.organizationId,
    country = this.country,
    language = this.language,
  }: {
    businessId?: string;
    organizationId?: string;
    country?: Country;
    language?: Language;
  } = {}): this {
    return BusinessChangedPayload.create({ businessId, organizationId, country, language }) as this;
  }

  isSame(other: BusinessChangedPayload): boolean {
    return this === other || (
      this.businessId === other.businessId &&
      this.organizationId === other.organizationId &&
      this.country === other.country &&
      this.language === other.language
    );
  }
}

export class BusinessChangedPayloadBuilder extends DataModelBuilder<BusinessChangedPayload> {
  build(context: SerializationContext, map: SerializedData): BusinessChangedPayload {
    return BusinessChangedPayload.fromMap(context, map);
  }
}
